import { Component, OnDestroy, OnInit } from '@angular/core';

import { ListDefaults, ListService, SearchFilter, TableService } from '@fry/lib/list';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { ActivatedRoute } from '@angular/router';
import { ExportListService } from '@fry/components/common/list/list/export-list/export-list.service';
import { switchMap } from 'rxjs';
import { FormField } from '@fry/lib/forms';
import { InteractiveTableOptions } from '@fry/components/common/list/interactive-table/interactive-table.component';
import { TransactionsStore } from '../lib';


@Component({
    selector: 'eas-payment-list',
    templateUrl: './payment.list.component.html',
    providers: [
        ListService,
        ExportListService,
        TableService,
    ],
    standalone: false
})
export class PaymentListComponent implements OnInit, OnDestroy {

  public actions: EASLinkAction[] = [];

//   public defaultColumns = [
//     'user', 'stateName', 'createdDate', 'view', 'bookingOption', 'bookingItem'
//   ];

  public tableComponentOptions: InteractiveTableOptions = {
    enableColumns: true,
    enableFilters: true,
    enableExport: true,
    enableSelection: false,
    itemSingleLabel: $localize `transaction`,
    itemPluralLabel: $localize `transactions`,
  };

  constructor(
    private route: ActivatedRoute,
    private tableService: TableService,
    private transactionsStore: TransactionsStore,
  ) { }

  private getExportFormFields(): FormField[] {
    return [
    ];
  }

  ngOnInit() {
    this.route.params.pipe(
      switchMap(_params => {
        const filter: SearchFilter = {};
        // const data = this.route.snapshot.data;
        const defaults: ListDefaults = { listType: 'table', engine: 'es', pageSize: 10 };
        defaults.fixedSearchModel = {
          filter,
          sort: {sort_on: 'addedDate', sort_order: 'desc'},
        //   select: ["user", "stateName", "createdDate", "modifiedDate", "view"],
          options: {
            includeFormFields: true
          },
        };
        // defaults.hideFilters = ['bookingItem', 'bookingOptionUnique'];
        defaults.exportFormFields = this.getExportFormFields();
        defaults.featuredFilters = ['text', 'state'];
        defaults.preserveState = true;
        return this.tableService
          .setupWith(this.transactionsStore,
                    defaults,
                    'all-transactions');
      })
    ).subscribe();

  }

  ngOnDestroy() { }
}
